import { render, staticRenderFns } from "./payment-status.vue?vue&type=template&id=3017b060&scoped=true"
import script from "./payment-status.vue?vue&type=script&lang=js"
export * from "./payment-status.vue?vue&type=script&lang=js"
import style0 from "./payment-status.vue?vue&type=style&index=0&id=3017b060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3017b060",
  null
  
)

export default component.exports